import axios from 'axios';

const service = {
    getUserProfile: async() => {
        let uri = '/peserta/profil/';
        let url = process.env.REACT_APP_API_URL + uri;
        
        let token = localStorage.getItem('token') || '';
        let id_user = localStorage.getItem('id_user') || '';
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };
    
        var profil = await axios.get(`${url}` + id_user, {headers});

        return profil
    }
}

export default service